/* "You may also like" (sections/related-products.liquid).
   Same-artist cards are already on the page; this fills the remaining spaces with Shopify's related
   recommendations: no duplicates, same product type only, and movie posters first on movie-poster pages
   (non-posters first elsewhere), keeping Shopify's relevance order within each group. */
if (!customElements.get('bdp-related-products')) {
  class BdpRelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this._started || !this.dataset.url) return;
      this._started = true;

      this.grid = this.querySelector('[data-bdp-grid]');
      this.heading = this.querySelector('.related-products__heading');
      this.limit = parseInt(this.dataset.limit, 10) || 4;
      if (!this.grid) return;

      if (this.grid.children.length >= this.limit) {
        this.finish();
        return;
      }

      new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      ).observe(this);
    }

    load() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const items = Array.from(doc.querySelectorAll('[data-bdp-recs] > li'));
          const seen = new Set([this.dataset.productId]);
          Array.from(this.grid.children).forEach((li) => seen.add(li.dataset.productId));

          const movie = this.dataset.movie === '1';
          const sameKind = (li) => (li.dataset.movie === '1') === movie;
          const picks = items
            .filter((li) => !seen.has(li.dataset.productId) && li.dataset.type === this.dataset.type)
            .filter((li) => li.querySelector('.card-wrapper'));
          const ordered = picks.filter(sameKind).concat(picks.filter((li) => !sameKind(li)));

          ordered.slice(0, Math.max(0, this.limit - this.grid.children.length)).forEach((li) => {
            this.grid.appendChild(document.adoptNode(li));
          });
        })
        .catch((e) => console.error(e))
        .finally(() => this.finish());
    }

    finish() {
      if (this.grid.children.length) {
        if (this.heading) this.heading.hidden = false;
        this.classList.add('product-recommendations--loaded');
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('bdp-related-products', BdpRelatedProducts);
}
